import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, CardTitle,CardText, Form, Container, Button, Alert, Modal, Input } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { useHistory, useParams } from "react-router-dom"
 import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

import axios from 'axios';
import { HRConfig, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import * as url from 'helpers/url_helper';

import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Select from 'react-select';

import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'

    const GrievanceDetails = () => {
        const history = useHistory();
        const {id} = useParams()

        const [inputs, setInputs] = useState([]);
        const [empNo, setEmpNo] = useState('');
        const [empName, setEmpName] = useState('');
        const [empTitle, setEmpTitle] = useState('');
        const [description, setDescription] = useState('')
        const [isloading, setIsloading] = useState(false);
        const [userError, setUserError] = useState(true);
        const [ipaSaved, setIpaSaved] = useState(false)
        const [ipaNo, setIpaNo] = useState('')

        const [modal_item, setmodal_item] = useState(false);

        const [caseOptions, setCaseOptions] = useState([])
        const [entryTypes, setEntryTypes] = useState(["Issue Detail Description","Findings","Recommendations","Employee Response"])
        
        const [natureofGrievance, setNatureofGrievance] = useState('')
        const [processType, setProcessType] = useState('')
        const [pTypeList, setPTypeList] = useState(["Job Description and Responsibilities", "Renumeration and Benefits", "Work Environment and Culture", "Work Enablers and Gear", "Safety and Security Concerns", "AOB - Please provide details in Issue Description"])

        const [employeesOptions, setEmployeesOptions] = useState([])
        const [sendToNo, setSetToNo] = useState('')
        const [inditedNo, setInditedNo] = useState('')
        const [caseDetails, setCaseDetails] = useState('')
        const [copyTo, setCopyTo] = useState('')
        const [witnesses, setWitnesses] = useState([])
        const [ctype, setType] = useState('')
        const [category, setCategory] = useState('')
        const [raisedDate, setRaisedDate] = useState(formatDate(new Date))
        const [incidentDate, setIncidentDate] = useState(formatDate(new Date))
        const [gDCode, setGDCode] = useState('')
        const [selectedEntryType, setSelectedEntryType] = useState('Issue Detail Description')
        const [wholeCase, setWholeCase] = useState(null)
        const [isLoading, setIsLoading] = useState(false)

        const [gNo, setGNo] = useState('')
        const [gStatus, setGStatus] = useState('')
        const [gDetails, setGDetails] = useState('')
        const [indictedName, setIndictedName] = useState('')
        const [currentUser, setCurrentUser] = useState('')
        
        const [gvLines, setGvLines] = useState([])

        const handleAddItem = () =>{
            const itemLine =  {
                "EntryType": selectedEntryType,
                "Description": description
            } 
            setGvLines([...gvLines, itemLine])
            tog_item()
        }

       
        toastr.options = TOAST_OPTIONS;
        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const handleWithdrawCase = () =>{
            setIsloading(true)
            const data = {no: gNo }
            axios.post(url.WITHDRAWCASE, JSON.stringify(data), HRConfig).then((r)=>{
                console.log(r)
                setIsloading(false)
                toastr.error("Case withdrawn")
                getData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
                toastr.error(e.response.data.error.message)
            })
        }
        const handleCloseCase = () =>{
            setIsloading(true)
            const data = {no: gNo }
            axios.post(url.CLOSECASE, JSON.stringify(data), HRConfig).then((r)=>{
                console.log(r)
                setIsloading(false)
                toastr.error("Case Closed")
                getData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
                toastr.error(e.response.data.error.message)
            })
        }
        const handleNotifySupervisor = () => {
            setIsloading(true)
            const data = {no: gNo }
            axios.post(url.NOTIFY_SUPERVISOR, JSON.stringify(data), HRConfig).then((r)=>{
                setIsloading(false)
                toastr.success(r.data.value)
                getData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
                toastr.error(e.response.data.error.message)
            })

        }
        const handleDeleteOpenCase = () =>{
            setIsloading(true)
            const data = {no: gNo }
            axios.post(url.DELETECASE, JSON.stringify(data), HRConfig).then((r)=>{
                setIsloading(false)
                toastr.error(r.data.value)
                history.push("/grievance-cases")
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
                toastr.error(e.response.data.error.message)
            })
        }
        const getData = () =>{
            setIsloading(true)
            if (localStorage.getItem("authUser")) {
                const obj = JSON.parse(localStorage.getItem("authUser"));
                setCurrentUser(obj.uid)
            }
            axios.get(`${url.GRIEVENCES}(${id})?$expand=grievanceLines`, HRConfig).then((r)=>{
                //console.log(r.data)
                setEmpNo(r.data.CaseRegisteredByNo)
                setEmpName(r.data.CaseRegisteredByName)
                setGNo(r.data.No)
                setGStatus(r.data.Status)
                setGDetails(r.data.DisciplinaryCaseDescripiton)
                setNatureofGrievance(r.data.NatureofGrievance)
                setProcessType(r.data.ProcessType)
                setIncidentDate(r.data.IncidentDate)
                setRaisedDate(r.data.DateRaised)
                setType(r.data.Type)
                setCategory(r.data.CaseCategory)
                setSetToNo(r.data.SendGrievanceTo)
                setCopyTo(r.data.CopyGrievancyTo)
                setInditedNo(r.data.EmployeeNo)
                setIndictedName(r.data.NameOfIndicted)
                setGDCode(r.data.GDCode)
                setGvLines(r.data.grievanceLines)
                axios.get(url.EMPLOYEES + "?$filter=No eq '"+ r.data.CaseRegisteredByNo +"'", HRConfig).then(function(response){
                    setIsloading(false)
                    setEmpTitle(response.data.value[0].JobTitle);
                }).catch(function (error) {  console.log(error);  setIsloading(true) })
            
            }).catch((e)=>{ console.log(e)})
            
            axios.get(url.EMPLOYEES, HRConfig).then((r)=>{ 
                let options = []
                r.data.value.map((e)=>{
                    options.push({label: `${e.FirstName} ${e.LastName}`,value: e.No})
                })
                setEmployeesOptions(options)
            }).catch((e)=>{ console.log(e) })
            axios.get(url.GRIEVANCE_TYPES, HRConfig).then((r)=>{ 
                let options = []
                r.data.value.map((e)=>{
                    options.push({label: `${e.Description}`,value: e})
                })
                setCaseOptions(options)
            }).catch((e)=>{ console.log(e) })
        }
        
        useEffect(()=>{
           getData()
        },[])
        
        const tog_item = () => {
            setmodal_item(!modal_item);
            removeBodyCss();
        }

        const handleChange = (event) => {
             const name = event.target.name;
             const value = event.target.value;
             setInputs(values => ({...values, [name]: value}));
        }
        
        const handleAddResponse = () =>{
            setIsloading(true)
            const data = {
                "IssueNo"       : gNo,
                "EntryType"     : "Employee Response",
                "Description"   : description
            }
            const data2 = {"no":gNo}
            axios.post(url.GRIEVANCELINES, JSON.stringify(data), HRConfig).then((r)=>{
                
                toastr.error("Response Sent")
                axios.post(url.SENDRESPONSE, JSON.stringify(data2), HRConfig).then((rx)=>{
                    setIsloading(false)
                    toastr.error(rx.data.value)
                    tog_item()
                    getData()
                }).catch((ex)=>{
                    console.log(ex)
                    setIsloading(false)
                })
                
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
                toastr.error(e.response.data.error.message)
            })
          
        }
        

        

        
        return (
      
            <LoadingOverlay
                active={isloading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Grievance Details | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Human Resource Management" breadcrumbItem="Grievance Details" />
                        <div>
            

                        {(ipaSaved == false) ? (
                        <Row>
                        <Col xl={4}>
                        <Card>
                            <CardBody>
                            <CardTitle>Grievance Raised By</CardTitle>
                                    <Row>
                                    <Col md={12}>
                                        <div className="form-floating mb-3">
                                        <input type="text" className="form-control EmployeeNo" disabled={true}  value = {empNo} onChange={handleChange}  />
                                        <label htmlFor="floatingIdInput">No</label>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="form-floating mb-3">
                                        <input  type="text" className="form-control" disabled={true} defaultValue={empName} onChange={handleChange}   />
                                        <label htmlFor="floatingnameInput">Name</label>
                                        </div>
                                    </Col>
                                    </Row>
                                    <Row>
                              
                                    <Col md={12}>
                                        <div className="form-floating mb-3">
                                        <input  type="text" className="form-control" disabled={true} defaultValue={empTitle} onChange={handleChange} />
                                        <label htmlFor="floatingDepartInput">Title</label>
                                        </div>
                                    </Col>
                                   
                                </Row>
                                
                                
                                </CardBody>
                            </Card>

                            </Col>
                            <Col  xl={8}>
                            <Card>
                            <CardBody>
                            <CardTitle></CardTitle>
                                <Row>
                                <Col md={4}>
                                    <div className="mb-3">
                                    <label htmlFor="floatingDepartInput">No</label>
                                    <Input type="text" className="form-control" defaultValue={gNo} disabled={true} />
                                    </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                        <label htmlFor="floatingDepartInput">Status</label>
                                        <Input type="text" className="form-control" defaultValue={gStatus} disabled={true} />
                                        
                                        </div>
                                </Col>
                                <Col md={4} className=" mb-3">
                                        
                                        <label htmlFor="floatingDepartInput">Grievance</label>
                                        <Input type="text" className="form-control" defaultValue={gDetails} disabled={true} />
                                       
                                </Col>
                                <Col lg={4}>
                                                <div className=" mb-3">
                                                <label htmlFor="floatingDepartInput">Nature Of Grievance</label>
                                                <Input type="text" className="form-control" defaultValue={natureofGrievance} disabled={true} />
                                                    
                                                </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                        <label htmlFor="floatingDepartInput">Process Type</label>
                                        <Input type="text" className="form-control" defaultValue={processType} disabled={true} />
                                        </div>
                                    </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                        <label htmlFor="floatingDepartInput">GD Code</label>
                                        <Input type="text" className="form-control" defaultValue={gDCode} disabled={true} />
                                        
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                        <label htmlFor="floatingDepartInput">Date of Incident</label>
                                        <Input type="text" className="form-control" defaultValue={incidentDate} disabled={true} />
                                        
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                        <label htmlFor="floatingDepartInput">Date Raised</label>
                                        <Input type="text" className="form-control" defaultValue={raisedDate} disabled={true} />
                                        
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                        <label htmlFor="floatingDepartInput">Type</label>
                                        <Input type="text" className="form-control" defaultValue={ctype} disabled={true} />
                                        </div>
                                    </Col>
                                 
                            
                            
                             
                                    <Col md={4}>
                                        <div className=" mb-3">
                                        <label htmlFor="floatingDepartInput">Send Grievance To</label>
                                        <Input type="text" className="form-control" defaultValue={sendToNo} disabled={true} />
                                        </div>
                                    </Col>
                             
                                    <Col md={4}>
                                        <div className=" mb-3">
                                        <label htmlFor="floatingDepartInput">Copy Grievance To</label>
                                        <Input type="text" className="form-control" defaultValue={copyTo} disabled={true} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className=" mb-3">
                                        <label htmlFor="floatingDepartInput">Name of Indicted</label>
                                        <Input type="text" className="form-control" defaultValue={indictedName} disabled={true} />
                                        </div>
                                    </Col>
                          
                          
                                 
                                  
                                    
                                    </Row>
                                    </CardBody>
                                    </Card>
                                 
                                    {(gvLines || []).map((g, key)=>(
                                        <Row key={key}>
                                            <Col>
                                            <Card>
                                        <CardBody>
                                
                                        <CardTitle className="mb-3">
                                        Grievance line  {key+1} 
                                        </CardTitle>
                                            <Row >
                        
                                            <Col lg={4}>
                                            <div className="mb-3">
                                                <label htmlFor="floatingSelectGrid">Entry Type</label>
                                                <input  type="text" className="form-control" defaultValue={g.EntryType} disabled={true} />
                                            </div>
                                            </Col>
                                            <Col lg={8}>
                                            <div className="mb-3">
                                                <label htmlFor="floatingSelectGrid">Description</label>
                                                <input  type="text" className="form-control" defaultValue={g.Description} disabled={true} />
                                            </div>
                                            </Col>
                                
                                            </Row>
                                            </CardBody>
                                            </Card>
                                            </Col>
                                        </Row>
                                    ))}
                                    
                                    <Row>
                                            {(gStatus == "Open") && (
                                                <>
                                                <Col md={6}>
                                                <div className="d-grid gap-2">
                                                    <input
                                                        type="button"
                                                        className="btn btn-warning mt-3 mt-lg-0"
                                                        value="Notify Respondent"
                                                        onClick={() => {  handleNotifySupervisor() }}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="d-grid gap-2">
                                                    <input
                                                        type="button"
                                                        className="btn btn-danger mt-3 mt-lg-0"
                                                        value="Delete Case"
                                                        onClick={() => {  handleDeleteOpenCase() }}
                                                    />
                                                </div>
                                            </Col>
                                                </>
                                            
                                            )}
                                            {(gStatus == "Employee Response") && (currentUser == empNo) && (
                                            <>
                                            <Col md={6}>
                                                <div className="d-grid gap-2">
                                                    <Button color="secondary" type="button" className="btn" onClick={handleWithdrawCase}>
                                                        Withdraw Case
                                                    </Button>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="d-grid gap-2">
                                                    <Button color="success" type="button" className="btn" onClick={handleCloseCase}>
                                                        Close Case
                                                    </Button>
                                                </div>
                                            </Col>
                                            </>
                                            )}

                                            {(gStatus == "Submitted to Employee") && (currentUser == inditedNo) && (
                                            <>
                                            <Col md={12}>
                                                <div className="d-grid gap-2">
                                                    <Button color="secondary" type="button" className="btn" onClick={()=>tog_item()}>
                                                        File Response
                                                    </Button>
                                                </div>
                                            </Col>
                              
                                            </>
                                            )}
                                            {(gStatus == "Submitted to Employee") && (currentUser == empNo) && (
                                            <>
                                            <Col md={12}>
                                                <div className="d-grid gap-2">
                                                    <Button color="secondary" type="button" className="btn" onClick={handleWithdrawCase}>
                                                        Withdraw Case
                                                    </Button>
                                                </div>
                                            </Col>
                                            </>
                                            )}
                                    </Row>
                                    
                                
                            </Col>
                            <Col>
                           
                                
                                    
                            <Modal
                                  isOpen={modal_item}
                                  toggle={() => {
                                    tog_item()
                                  }}
                                  centered
                                >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">Employee Response</h5>
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setmodal_item(false);
                                      }}
                                      className="close"
                                      data-dismiss="modal"
                                      aria-label="Close"
                                    >
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                            
                                    
                                
                                     
                                            <Row >
                        
                                            <Col lg={12}>
                                                <div className="mb-3">
                                                <label htmlFor="floatingDepartInput">Entry Type</label>
                                                <select className='form-select' onChange={(e)=>{setSelectedEntryType(e.target.value)}}>
                                                    <option value="Employee Response">Employee Response</option>
                                                  </select>
                                                    
                                                </div>
                                            </Col>
                                     
                                           
                                            
                                            <Col lg={12}>
                                            <div className="mb-3">
                                                <label htmlFor="floatingSelectGrid">Description</label>
                                                <input  type="text" className="form-control" onChange={(e)=>setDescription(e.target.value)}   />
                                                
                                            </div>
                                            </Col>
                                            
                                            
                                         
                                            </Row>
                                          
                                            
                                            </div>
                                  <div className="modal-footer">
                                    <button
                                      type="button"
                                      onClick={() => {tog_item()}}
                                      className="btn btn-danger "
                                      data-dismiss="modal"
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-success "
                                      onClick={()=>{handleAddResponse()}}
                               
                                    >
                                      Add Response...
                                    </button>
                                  </div>
                                </Modal>
              
                                            
                                            <br/>
              
                                           
                    
                        </Col>
                        </Row>
                        ):(
                            <Row className="d-flex justify-content-center">
                                <Col lg={8} >
                                <Card outline color="success" className="border">
                                    <CardBody>
                                    <CardTitle className="mb-4 text-white">
                                        
                                    </CardTitle>
                                    <CardText>
                                        
                                    </CardText>
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-check-circle-outline text-success display-4" />
                                        </div>
                                        <div>
                                        <h5>Saved</h5>
                                        <p className="text-muted">
                                                Requisition <strong>{ipaNo}</strong> Saved!
                                        </p>
                                        </div>
                                    </div>
                                    </CardBody>
                                </Card>
                                </Col>
                            </Row>
                        )}
                        </div>


                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
         

        );
    }

export default GrievanceDetails;